export default "__VITE_ASSET__C8Ct3Q2i__"